"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
exports.constants = {
    GOOGLE_ADDRESS_AUTOCOMPLETE_NAMESPACE: "boutik-gatsby-plugin-components-googleAddressAutocomplete",
    FORM_INPUTS_NAMESPACE: "boutik-gatsby-plugin-components-formInputs",
};
//# sourceMappingURL=constants.js.map